import { Button, ButtonProps } from '@mui/material';
import { ReactNode } from 'react';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import PreDialog from './presentations/PreDialog/PreDialog';

type Props = {
  onAcknowledge: () => void;
  title: string;
  description: string | ReactNode;
  buttonText: string;
  cancelText?: string;
  open: boolean;
  onClose: () => void;
  slotProps?: {
    confirmButton?: ButtonProps;
  };
};

export function WarningModal({
  title,
  description,
  buttonText,
  onAcknowledge,
  cancelText,
  open,
  onClose,
  slotProps,
}: Props) {
  return (
    <PreDialog
      open={open}
      onClose={onClose}
      type="definedByProperty"
      dialogtitle={title}
      content={<PTypography variant="body1">{description}</PTypography>}
      actions={
        <>
          {cancelText ? (
            <Button variant="outlined" onClick={onClose}>
              {cancelText}
            </Button>
          ) : null}
          <Button variant="contained" onClick={onAcknowledge} autoFocus {...slotProps?.confirmButton}>
            {buttonText}
          </Button>
        </>
      }
    />
  );
}
